module.exports = __webpack_public_path__ + "img/1586265134.cd324b39.jpg";